
import React, { useEffect, useState, } from "react";
import {
    Col,
    FormGroup,
    Input,
    Label,
} from "reactstrap";
import { MetaTags } from "react-meta-tags";
import { BreadcrumbShowCountlabel, GetVender, GoButtonForChallanAddSuccess, ManuallyOrderClose, VDC_Item, VDC_Item_Details, commonPageFieldSuccess, makeGRN_Mode_1ActionSuccess, saveChallan_ChallanAdd, saveChallan_ChallanAddSuccess } from "../../../store/actions";
import { useDispatch, useSelector } from "react-redux";
import { commonPageField } from "../../../store/actions";
import { useHistory } from "react-router-dom";
import {
    comAddPageFieldFunc,
    initialFiledFunc,
    onChangeDate,
    onChangeSelect,
} from "../../../components/Common/validationFunction";
import Select from "react-select";
import { Go_Button, SaveButton } from "../../../components/Common/CommonButton";
import * as mode from "../../../routes/PageMode";
import * as pageId from "../../../routes/allPageID"
import * as url from "../../../routes/route_url"

import { customAlert } from "../../../CustomAlert/ConfirmDialog";
import {
    orderQtyOnChange,
    orderQtyUnit_SelectOnchange,
    stockQtyOnChange,
    settingBaseRoundOffAmountFunc,
    ChallanCalculateFunc,
    stockDistributeFunc,
    discountRecalcFunc,
} from "./IBInvoiceCalculation";
import * as _cfunc from "../../../components/Common/CommonFunction";
import { C_DatePicker, CInput, decimalRegx } from "../../../CustomValidateForm";

import GlobalCustomTable from "../../../GlobalCustomTable";
import SaveButtonDraggable from "../../../components/Common/saveButtonDraggable";
import { alertMessages } from "../../../components/Common/CommonErrorMsg/alertMsg";
import { showToastAlert } from "../../../helpers/axios_Config";
import useCheckStockEntry from "../../../components/Common/commonComponent/CheckStockEntry";
import { getDriverList } from "../../../store/Administrator/DriverRedux/action";
import { getVehicleList } from "../../../store/Administrator/VehicleRedux/action";
import { Invoice_Send_To_SAP } from "../../../helpers/backend_helper";


const PageDetailsFunc = (subPageMode) => {
    let pageID = null;
    let listPath = null;
    if (subPageMode === url.IB_INVOICE) {
        pageID = pageId.IB_INVOICE;
        listPath = url.IB_INVOICE_LIST
    } else if (subPageMode === url.VDC_INVOICE) {

        pageID = pageId.VDC_INVOICE;
        listPath = url.VDC_INVOICE_LIST
    } else if (subPageMode === url.CHALLAN_MASTER) {
        pageID = pageId.CHALLAN_MASTER;
        listPath = url.CHALLAN_MASTER_LIST
    }

    return { pageID, listPath, }
}



const IBInvoice = (props) => {

    const dispatch = useDispatch();
    const history = useHistory();
    const currentDate_ymd = _cfunc.date_ymd_func();
    const subPageMode = history.location.pathname
    const PageDetails = PageDetailsFunc(subPageMode)
    const saveBtnid = `saveBtn${subPageMode}`

    const fileds = {
        ChallanDate: currentDate_ymd,
        Customer: "",
        VehicleNo: "",
        VDCItem: "",
        Party: "",
        DriverName: ""
    }

    const [state, setState] = useState(() => initialFiledFunc(fileds))
    const [orderItemDetails, setOrderItemDetails] = useState([])
    const [customerID, setCustomerID] = useState([]);

    const [Demand_ID, setDemandID] = useState({ Demand_ID: "" });

    const [tableData, setTableData] = useState([]);
    const ChallanMaster = subPageMode === url.CHALLAN_MASTER
    const isRACompany = _cfunc.isRACompany()

    const showDiscount = ChallanMaster && isRACompany;

    // header "apply to all" discount
    const [discountValueAll, setDiscountValueAll] = useState("");
    const [discountTypeAll, setDiscountTypeAll] = useState({ value: 2, label: " % " });
    const [discountDropOption] = useState([{ value: 1, label: "Rs" }, { value: 2, label: "%" }]);
    const [changeAllDiscount, setChangeAllDiscount] = useState(false);

    // re-run discount calc after any IB handler has updated the row
    const applyDiscountCalc = (row) => {
        if (showDiscount) discountRecalcFunc(row);
    };
    // ****************************************************************************


    // ****************************************************************************

    const [pageMode, setPageMode] = useState(mode.defaultsave);
    const [userPageAccessState, setUserAccState] = useState('');

    const {
        postMsg,
        pageField,
        userAccess,
        saveBtnloading,
        saveAndPdfBtnLoading,
        commonPartyDropSelect,
        StockEnteryForFirstYear,
        GRNitem,
        VDCItemData,
        vender,
        DriverList,
        VehicleNumber,
        gobutton_Add_invoice
    } = useSelector((state) => ({
        vender: state.CommonAPI_Reducer.vender,
        VDCItemData: state.ChallanReducer.VDCItemData,
        postMsg: state.ChallanReducer.postMsg,
        userAccess: state.Login.RoleAccessUpdateData,
        pageField: state.CommonPageFieldReducer.pageField,
        customer: state.CommonAPI_Reducer.customer,
        saveBtnloading: state.InvoiceReducer.saveBtnloading || state.ChallanReducer.saveBtnloading,
        saveAndPdfBtnLoading: state.InvoiceReducer.saveAndPdfBtnLoading,
        commonPartyDropSelect: state.CommonPartyDropdownReducer.commonPartyDropSelect,
        StockEnteryForFirstYear: state.StockEntryReducer.StockEnteryForFirstYear,
        GRNitem: state.GRNReducer.GRNitem,
        DriverList: state.DriverReducer.DriverList,
        VehicleNumber: state.VehicleReducer.VehicleList,
        gobutton_Add_invoice: state.InvoiceReducer.gobutton_Add_invoice
    }));


    const location = { ...history.location }
    const hasShowModal = props.hasOwnProperty("editValue")

    const values = { ...state.values }
    const { isError } = state;
    const { fieldLabel } = state;

    useEffect(() => {
        dispatch(makeGRN_Mode_1ActionSuccess({ Status: false }));
        const jsonBody = JSON.stringify({
            Party: _cfunc.loginSelectedPartyID(),
        })
        dispatch(commonPageFieldSuccess(null));
        dispatch(commonPageField(PageDetails.pageID))
        dispatch(GoButtonForChallanAddSuccess([]))
        dispatch(getDriverList({ ..._cfunc.loginJsonBody(), PartyID: _cfunc.loginPartyID() }));
        dispatch(getVehicleList({ ..._cfunc.loginJsonBody(), "PartyID": _cfunc.loginPartyID() }));
        if (subPageMode === url.VDC_INVOICE) {
            dispatch(VDC_Item({ jsonBody }))
        }
        dispatch(GetVender())

        return () => {
            dispatch(saveChallan_ChallanAddSuccess({ Status: false }))
            dispatch(makeGRN_Mode_1ActionSuccess({ Status: false }))
        }

    }, [])

    // userAccess useEffect
    useEffect(() => {
        let userAcc = null;
        let locationPath = location.pathname;

        if (hasShowModal) {
            locationPath = props.masterPath;
        };
        userAcc = userAccess.find((inx) => {
            return (`/${inx.ActualPagePath}` === locationPath)
        })

        if (userAcc) {
            setUserAccState(userAcc)
            _cfunc.breadcrumbReturnFunc({ dispatch, userAcc });
        };
    }, [userAccess])

    useEffect(() => {
        if (GRNitem.Status === true && GRNitem.StatusCode === 200) {

            const { DemandItemDetails } = GRNitem.Data

            if (subPageMode === url.IB_INVOICE || subPageMode === url.CHALLAN_MASTER) {

                setCustomerID({ value: GRNitem?.Demand_Reference[0]?.CustomerID, label: GRNitem?.Demand_Reference[0]?.CustomerName })
                setDemandID({ Demand_ID: Number(GRNitem?.Data.DemandIDs) })
            } else if (subPageMode === url.VDC_INVOICE) {

                setCustomerID(state.values.Customer)
            }
            let totalAmount = 0;
            const Updated_DemandDetails = DemandItemDetails.map((inx_1, key_1) => {
                inx_1.originalQuantity = Number(inx_1.Quantity);
                inx_1.originalBaseQty = Number(inx_1.BaseUnitQuantity);
                const isUnitIDPresent = inx_1?.UnitDetails?.find(findEle => findEle.UnitID === inx_1.Unit);
                const isMCunitID = inx_1?.UnitDetails?.find(findEle => findEle.DeletedMCUnitsUnitID === inx_1.DeletedMCUnitsUnitID);
                const defaultunit = isUnitIDPresent !== undefined ? isUnitIDPresent : isMCunitID;
                if (!defaultunit) {
                    showToastAlert(`${inx_1.ItemName} this Item Not getting defalut Unit id ,UnitId is not present in UnitDetails `)
                }
                let totalStockQty = 0;

                inx_1.StockInValid = false;
                inx_1.StockInvalidMsg = '';

                inx_1.default_UnitDropvalue = {//initialize
                    value: inx_1.Unit,
                    label: inx_1.UnitName,
                    ConversionUnit: ChallanMaster ? Number(defaultunit?.BaseUnitQuantity) : '1',
                    Unitlabel: inx_1.UnitName,
                    BaseUnitQuantity: defaultunit?.BaseUnitQuantity,
                    BaseUnitQuantityNoUnit: defaultunit?.BaseUnitQuantityNoUnit,
                };

                inx_1.InpStockQtyTotal = `${Number(inx_1.Quantity) * Number(inx_1.ConversionUnit)}`;

                inx_1.StockDetails = inx_1.StockDetails.map((inx_2, key_2) => {
                    inx_2.initialRate = inx_2.Rate;

                    const _hasRate = ((defaultunit?.BaseUnitQuantity / defaultunit?.BaseUnitQuantityNoUnit) * inx_2.initialRate);
                    const _hasActualQuantity = (inx_2.BaseUnitQuantity / defaultunit?.BaseUnitQuantity);


                    inx_2.Rate = _cfunc.roundToDecimalPlaces(_hasRate, 2);//max 2 decimal  //initialize
                    inx_2.ActualQuantity = _cfunc.roundToDecimalPlaces(_hasActualQuantity, 3);//max 3 decimal  //initialize



                    const stockQty = parseFloat(inx_2.ActualQuantity); // Convert to a number
                    totalStockQty += stockQty








                    inx_2.id = key_2;
                    return inx_2;
                })
                // Preserve a discount supplied by the Sales Order / source document.
                // New rows retain the existing Invoice defaults.
                inx_1.DiscountType = Number(inx_1.DiscountType) || 2;
                inx_1.Discount = inx_1.Discount ?? "";
                stockDistributeFunc(inx_1, ChallanMaster)

                totalAmount += inx_1.ItemTotalAmount
                inx_1.ItemTotalStock = _cfunc.roundToDecimalPlaces(totalStockQty, 3); //max 3 decimal

                inx_1.id = key_1; //max 2 decimal


                if (inx_1.ItemTotalStock < inx_1.Quantity) {
                    inx_1.StockInValid = true;
                    const diffrence = Math.abs(inx_1.ItemTotalStock - inx_1.Quantity);
                    const msg1 = `Short Stock Quantity ${(Number(inx_1.Quantity)).toFixed(3)}`;
                    const msg2 = `Short Stock Quantity ${(diffrence).toFixed(3)}`;
                    inx_1.StockInvalidMsg = inx_1.ItemTotalStock === 0 ? msg1 : msg2;
                }


                return inx_1;
            })

            totalAmountCalcuationFunc(Updated_DemandDetails)
            setTableData(Updated_DemandDetails)

            const commaSeparateAmount = _cfunc.amountCommaSeparateFunc(Number(totalAmount).toFixed(2));
            dispatch(BreadcrumbShowCountlabel(`Count:${Updated_DemandDetails.length} currency_symbol ${commaSeparateAmount}`))

        } else {
            if (GRNitem.Message) {
                customAlert({
                    Type: 4,
                    Message: GRNitem.Message,
                })

            }
        }
    }, [GRNitem])
    useEffect(() => {
        if (showDiscount && changeAllDiscount) {
            const updated = tableData.map((item) => ({
                ...item,
                Discount: discountValueAll,
                DiscountType: discountTypeAll.value,
            }));
            updated.forEach((row) => discountRecalcFunc(row));
            totalAmountCalcuationFunc(updated);
            setTableData(updated);
        }
    }, [changeAllDiscount, discountValueAll, discountTypeAll.value]);
    const venderOptions = vender.map((i) => ({
        value: i.id,
        label: i.Name,
    }));

    const DriverOptions = DriverList?.map(i => ({
        value: i.id,
        label: i.Name
    }));

    const VehicleNumber_Options = VehicleNumber.map((index) => ({
        value: index.id,
        label: index.VehicleNumber,
    }));

    useEffect(async () => {

        if ((postMsg.Status === true) && (postMsg.StatusCode === 200)) {
            dispatch(saveChallan_ChallanAddSuccess({ Status: false }))
            dispatch(makeGRN_Mode_1ActionSuccess({ Status: false }))
            setTableData([]);
            if (pageMode === mode.dropdownAdd) {
                customAlert({
                    Type: 1,
                    Message: postMsg.Message,
                })
            }
            else {
                let ApplicableAutoSendToSap = ""
                let Invoice_Send_Resp;
                if (_cfunc.IsSweetAndSnacksCompany() && _cfunc.loginSystemSetting()?.AutoInvoiceSendToSap === "1") {
                    ApplicableAutoSendToSap = "Auto Invoice Send To SAP"
                    const jsonBody = JSON.stringify({ InvoiceID: postMsg.TransactionID[0], TransactionType: "Challan" })//
                    try {
                        Invoice_Send_Resp = await Invoice_Send_To_SAP({
                            jsonBody
                        });
                    } catch (error) {
                        console.log(error);
                    }
                }
                // RA-only: force-close the order once its first Challan is saved
                // if (subPageMode === url.CHALLAN_MASTER) {
                //     const forceCloseOrderId = sessionStorage.getItem('forceCloseOrderOnChallan');
                //     if (forceCloseOrderId) {
                //         sessionStorage.setItem('silentOrderCloseForRA', 'true'); // NEW — suppress alert on OrderList
                //         dispatch(ManuallyOrderClose({
                //             jsonBody: JSON.stringify({ OrderID: Number(forceCloseOrderId), IsOrderClose: true }),
                //             btnId: saveBtnid
                //         }));
                //         sessionStorage.removeItem('forceCloseOrderOnChallan');
                //     }
                // }

                const applicableItems = [
                    ApplicableAutoSendToSap,
                ].filter(Boolean);
                customAlert({

                    Type: 12,
                    Message: JSON.stringify(postMsg.Message),
                    Title: applicableItems.length
                        ? "Applicable for " + applicableItems.join(" ")
                        : "",

                    TitleMessage: [Invoice_Send_Resp],
                    ActionButton: "OK",
                    Icon: "mdi mdi-check-all",
                    color: "success",
                });
                history.push({ pathname: PageDetails.listPath })
            }
        }
        else if (postMsg.Status === true) {
            dispatch(saveChallan_ChallanAddSuccess({ Status: false }))
            dispatch(makeGRN_Mode_1ActionSuccess({ Status: false }))
            customAlert({
                Type: 4,
                Message: JSON.stringify(postMsg.Message),
            })
        }
    }, [postMsg])

    useEffect(() => {
        if (pageField) {
            const fieldArr = pageField.PageFieldMaster
            comAddPageFieldFunc({ state, setState, fieldArr })
        }
    }, [pageField])

    useEffect(() => _cfunc.tableInputArrowUpDounFunc("#table_Arrow"), [orderItemDetails]);

    const pagesListColumns = [
        {//***************ItemName********************************************************************* */
            text: "Item Name",
            dataField: "ItemName",
            attrs: (cell, row, rowIndex, colIndex) => ({ 'data-label': "ItemName", "sticky-col": "true" }),
            // headerClasses: 'd-none d-sm-table-cell', // Hide on mobile
            formatter: (cellContent, index1) => {

                return (
                    <>
                        <div>
                            <samp className="theme-font"
                                id={`ItemName${index1.id}`}>{index1.ItemName}</samp>
                        </div>
                        <div style={{
                            overflow: "hidden",
                            whiteSpace: "nowrap",
                            width: "100%", // Set the width to the desired container width
                        }}>
                            <samp id={`StockInvalidMsg-${index1.id}`}
                                style={{
                                    display: index1.StockInValid ? "block" : "none",
                                    color: "red",
                                    animation: "scrollRightToLeft 15s linear infinite",
                                }}>
                                {index1.StockInvalidMsg}
                            </samp>
                        </div>
                    </>
                )
            },
        },
        {//***************Quantity********************************************************************* */
            text: "Quantity/Unit",
            dataField: "",
            formatExtraData: { tableList: tableData },
            attrs: () => ({ 'data-label': "Quantity/Unit" }),
            formatter: (cellContent, index1, keys_, { tableList = [] }) => {

                return (<>
                    <div>
                        <Input
                            type="text"

                            id={`OrderQty-${index1.id}`}
                            placeholder="Enter quantity"
                            className="right-aligned-placeholder mb-1"
                            style={{
                                border: index1.StockInValid ? '2px solid red' : "1px solid #ced4da"
                            }}
                            key={`OrderQty-${index1.id}`}
                            autoComplete="off"
                            defaultValue={Number(index1.Quantity).toFixed(3)}
                            onChange={(event) => {
                                
                                if (parseFloat(event.target.value) > index1.originalQuantity && !(subPageMode === url.VDC_INVOICE)) {
                                    event.target.value = index1.originalQuantity
                                }
                                orderQtyOnChange(event, index1, ChallanMaster);
                                applyDiscountCalc(index1);
                                totalAmountCalcuationFunc(tableList);
                            }}
                        />
                    </div>
                    <div>
                        <div id="select">
                            <Select
                                classNamePrefix="select2-selection"
                                id={"ddlUnit"}
                                isDisabled={pageMode === mode.edit && true}
                                defaultValue={index1.default_UnitDropvalue}
                                options={index1.UnitDetails.map(i => ({
                                    "label": i.UnitName,
                                    "value": i.UnitID,
                                    "ConversionUnit": i.ConversionUnit,
                                    "Unitlabel": i.UnitName,
                                    "BaseUnitQuantity": i.BaseUnitQuantity,
                                    "BaseUnitQuantityNoUnit": i.BaseUnitQuantityNoUnit,
                                }))}
                                onChange={(event) => {
                                    // NEW — RA company only: rescale current Quantity to the newly selected unit,
                                    // so it still represents the same physical amount before distribution runs
                                    if (isRACompany) {
                                        const oldUnitBaseQty = Number(index1.default_UnitDropvalue?.BaseUnitQuantity || 1);
                                        const newUnitBaseQty = Number(event?.BaseUnitQuantity || 1);
                                        const conversionRatio = newUnitBaseQty > 0 ? (oldUnitBaseQty / newUnitBaseQty) : 1;

                                        index1.Quantity = _cfunc.roundToDecimalPlaces(Number(index1.Quantity) * conversionRatio, 3);
                                    }

                                    // existing logic — unchanged
                                    orderQtyUnit_SelectOnchange(event, index1, ChallanMaster);
                                    applyDiscountCalc(index1);
                                    // NEW — RA company only: reflect the rescaled Quantity in the visible input
                                    if (isRACompany) {
                                        try {
                                            const orderQtyElement = document.getElementById(`OrderQty-${index1.id}`);
                                            if (orderQtyElement) orderQtyElement.value = Number(index1.Quantity).toFixed(3);
                                        } catch (error) { }
                                    }

                                    totalAmountCalcuationFunc(tableList);
                                }}
                            ></Select>
                        </div>
                    </div>
                    <div className="theme-font">
                        <span className="text-muted">PO-Qty :</span>
                        <samp>{index1.BaseUnitQuantity}</samp>&nbsp;&nbsp;
                        <samp>{index1.UnitName}</samp>
                    </div>
                    <div>
                        <samp className="theme-font text-muted" >Available stock :</samp>
                        <label className="text-black">{_cfunc.roundToDecimalPlaces(index1.ItemTotalStock, 3)}</label>
                    </div>
                </>
                )
            },
        },
        {//***************StockDetails********************************************************************* */
            text: "Stock Details",
            dataField: "StockDetails",
            attrs: () => ({ 'data-label1': "Stock Details", "stock-header": "true" }),
            headerStyle: { zIndex: "2" },
            formatExtraData: { tableList: tableData },
            formatter: (cellContent, index1, keys_, { tableList = [] }) => {
                return (
                    <div className="table-responsive">
                        <table className="custom-table ">
                            <thead >
                                <tr>
                                    <th>BatchCode</th>
                                    <th>Stock </th>
                                    <th>Quantity</th>
                                    <th>Basic Rate</th>
                                    {/* <th>MRP</th> */}
                                </tr>
                            </thead>
                            <tbody>
                                {cellContent.map((index2) => (
                                    <tr key={index1.id}>
                                        <td data-label="BatchCode">{index2.BatchCode}</td>
                                        <td data-label="Stock Quantity" style={{ textAlign: "right" }} >
                                            <samp id={`ActualQuantity-${index1.id}-${index2.id}`}>{index2.ActualQuantity}</samp>
                                        </td>
                                        <td data-label='Quantity'>
                                            <Input
                                                type="text"
                                                placeholder="Manually enter quantity"
                                                className="right-aligned-placeholder"
                                                key={`batchQty${index1.id}-${index2.id}`}
                                                id={`batchQty${index1.id}-${index2.id}`}
                                                defaultValue={index2.Qty !== "" && !isNaN(parseFloat(index2.Qty))
                                                    ? parseFloat(index2.Qty).toFixed(3)
                                                    : 0}
                                                onChange={(event) => {
                                                    
                                                    // if (event.target.value == "") {
                                                    //     event.target.value = 0
                                                    // }

                                                    if (parseFloat(event.target.value) > index2.ActualQuantity) {
                                                        event.target.value = index2.ActualQuantity

                                                    }
                                                    // 🔴 Block increase — check the RUNNING TOTAL across all batch rows, not just this row
                                                    // if (subPageMode === url.CHALLAN_MASTER) {
                                                    //     const currentUnitBaseQty = Number(index1.default_UnitDropvalue?.BaseUnitQuantity || 1);
                                                    //     const maxAllowedInSelectedUnit = _cfunc.roundToDecimalPlaces(index1.originalBaseQty / currentUnitBaseQty, 3);

                                                    //     const otherRowsTotal = index1.StockDetails.reduce((sum, row) => {
                                                    //         return row.id === index2.id ? sum : sum + Number(row.Qty);
                                                    //     }, 0);
                                                    //     const newQty = Number(event.target.value).toFixed(3); // keep as a real number, not a string
                                                    //     const projectedTotal = _cfunc.roundToDecimalPlaces(otherRowsTotal + newQty, 3);


                                                    //     if (projectedTotal > maxAllowedInSelectedUnit) {
                                                    //         event.target.value = Number(index2.Qty).toFixed(3); // revert only this row's box
                                                    //         customAlert({
                                                    //             Type: 4,
                                                    //             Message: `Total quantity cannot exceed Challan quantity (${maxAllowedInSelectedUnit}). Already allocated: ${otherRowsTotal}`
                                                    //         });
                                                    //         return;
                                                    //     }
                                                    // }
                                                    stockQtyOnChange(event, index1, index2, subPageMode === url.VDC_INVOICE, ChallanMaster);
                                                    applyDiscountCalc(index1);
                                                    totalAmountCalcuationFunc(tableList);
                                                }}
                                            />
                                        </td>
                                        <td data-label='Basic Rate' style={{ textAlign: "right" }}>
                                            <span id={`stockItemRate-${index1.id}-${index2.id}`}>{_cfunc.amountCommaSeparateFunc(index2.Rate)}</span>
                                        </td>
                                        {/* <td data-label='MRP' style={{ textAlign: "right" }}>{_cfunc.amountCommaSeparateFunc(_cfunc.roundToDecimalPlaces(index1.MRP, 2))}</td> */}
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )
            },
        },
        {
            text: "Discount/unit",
            dataField: "",
            hidden: !showDiscount,
            attrs: () => ({ 'data-label': "Discount/unit" }),
            formatExtraData: { tableList: tableData },
            classes: () => "invoice-discount-row",
            headerFormatter: () => (
                <div>
                    {tableData.length <= 0 ? (
                        <div className="col col-3 mt-2"><Label>Discount/unit</Label></div>
                    ) : (
                        <div className="row">
                            <div className="mt-n2 mb-n2"><Label>Discount/unit</Label></div>
                            <div className="col col-6" style={{ width: "100px" }}>
                                <Select
                                    defaultValue={discountTypeAll}
                                    classNamePrefix="select2-selection"
                                    options={discountDropOption}
                                    styles={{ menu: p => ({ ...p, zIndex: 55 }) }}
                                    onChange={(e) => {
                                        setChangeAllDiscount(true);
                                        setDiscountTypeAll(e);
                                        setDiscountValueAll('');
                                    }}
                                />
                            </div>
                            <div className="col col-6" style={{ width: "100px" }}>
                                <CInput
                                    type="text"
                                    className="right-aligned-placeholder"
                                    cpattern={decimalRegx}
                                    placeholder="Enter discount value"
                                    value={discountValueAll}
                                    onChange={(e) => {
                                        e.target.value = e.target.value.replace(/^\.+/, '');
                                        e.target.value = e.target.value.replace(/^00+/, '0');
                                        const e_val = Number(e.target.value);
                                        if (discountTypeAll.value === 2) {
                                            if (e_val >= 100) e.target.value = 100;
                                            else if (!(e_val >= 0 && e_val < 100)) e.target.value = "";
                                        }
                                        setChangeAllDiscount(true);
                                        setDiscountValueAll(e.target.value);
                                    }}
                                />
                            </div>
                        </div>
                    )}
                </div>
            ),
            formatter: (cellContent, index1, key, { tableList }) => {
                if (!index1.DiscountType) index1.DiscountType = discountTypeAll.value;
                const defaultDiscountTypelabel =
                    (index1.DiscountType === "1" || index1.DiscountType === 1) ? discountDropOption[0] : discountDropOption[1];

                return (
                    <>
                        <div className="mb-2">
                            <div className="parent">
                                <div className="child"><label className="label">Type&nbsp;&nbsp;&nbsp;</label></div>
                                <div className="child">
                                    <Select
                                        id={`DicountType_${key}`}
                                        classNamePrefix="select2-selection"
                                        key={`DicountType_${key}-${index1.id}`}
                                        value={defaultDiscountTypelabel}
                                        options={discountDropOption}
                                        onChange={(e) => {
                                            setChangeAllDiscount(false);
                                            index1.DiscountType = e.value;
                                            index1.Discount = '';
                                            applyDiscountCalc(index1);
                                            totalAmountCalcuationFunc(tableList);
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                        <div>
                            <div className="parent">
                                <div className="child"><label className="label">Value&nbsp;</label></div>
                                <div className="child">
                                    <CInput
                                        id={`Dicount_${key}-${index1.id}`}
                                        className="right-aligned-placeholder"
                                        type="text"
                                        placeholder="Enter discount value"
                                        value={index1.Discount}
                                        cpattern={decimalRegx}
                                        onChange={(e) => {
                                            e.target.value = e.target.value.replace(/^\.+/, '');
                                            e.target.value = e.target.value.replace(/^00+/, '0');
                                            const e_val = Number(e.target.value);
                                            if (index1.DiscountType === 2) {
                                                if (e_val >= 100) e.target.value = 100;
                                                else if (!(e_val >= 0 && e_val < 100)) e.target.value = "";
                                            }
                                            index1.Discount = e.target.value;
                                            setChangeAllDiscount(false);
                                            applyDiscountCalc(index1);
                                            totalAmountCalcuationFunc(tableList);
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                    </>
                );
            },
        },
        {//*************** Amount ****************/
            text: "Amount",
            dataField: "ItemTotalAmount",
            formatExtraData: { tableList: tableData },
            formatter: (cellContent, index1) => {
                return (
                    <div style={{ textAlign: "right" }} id={`item-TotalAmount-${index1.id}`}>
                        {_cfunc.amountCommaSeparateFunc(_cfunc.getFixedNumber(cellContent, 2))}
                    </div>
                )
            },
        },
    ];

    const totalAmountCalcuationFunc = (tableList = []) => {

        const calcalateGrandTotal = settingBaseRoundOffAmountFunc(tableList)
        const dataCount = tableList.length;
        const total = Number(calcalateGrandTotal.sumOfGrandTotal);
        const commaSeparateAmount = _cfunc.amountCommaSeparateFunc(total.toFixed(2));

        dispatch(BreadcrumbShowCountlabel(`Count:${dataCount} currency_symbol ${commaSeparateAmount}`))

    }




    const { Actionhandler } = useCheckStockEntry(commonPartyDropSelect);


    function ChallanDateOnchange(y, v, e) {
        onChangeDate({ e, v, state, setState })
    };

    const VDCItem_Options = VDCItemData.map((index) => ({

        value: index.ItemID,
        label: index.ItemName,
    }));


    function ItemOnchange(e) {
        setState((i) => {
            const a = { ...i }
            a.values.VDCItem = e;
            return a
        })
        setTableData([])
    }

    const goButtonHandler = () => {

        if (values.VDCItem === "") {
            customAlert({
                Type: 3,
                Message: alertMessages.itemNameIsRequired,
            })
            return
        }
        const filter = JSON.stringify({
            ChallanDate: values.ChallanDate,
            ItemID: values.VDCItem.value,
            Party: commonPartyDropSelect.value,
            Customer: values.Customer.value
        });
        Actionhandler({
            transactionDate: values.ChallanDate,  // ✅ pass date here
            action: VDC_Item_Details,
            params: { filter },
        });
    }

    function venderOnchange(e) {
        setState((i) => {
            const a = { ...i }
            a.values.Customer = e;
            return a
        })

    }


    const saveHandeller = (e,) => {

        const itemArr = []
        let hasZeroRate = false;
        let zeroRateItemName = "";
        let grand_total = 0;
        tableData.forEach(tableIndex => {
            tableIndex.StockDetails.forEach(stockIndex => {
                if ((Number(stockIndex.Qty) > 0)) {
                    if (Number(stockIndex.Rate) === 0) {
                        hasZeroRate = true;
                        zeroRateItemName = tableIndex.ItemName;
                    }

                    const calculate = ChallanCalculateFunc({
                        ...stockIndex,
                        Discount: showDiscount ? tableIndex.Discount : 0,
                        DiscountType: showDiscount ? tableIndex.DiscountType : 2,
                    }, undefined, subPageMode);

                    grand_total += Number(calculate.roundedTotalAmount);
                    const arr = {
                        Item: tableIndex.Item,
                        Quantity: Number(stockIndex.Qty).toFixed(3),
                        Unit: tableIndex.default_UnitDropvalue.value,
                        BaseUnitQuantity: stockIndex.BaseUnitQuantity,
                        MRP: isRACompany ? tableIndex?.MRP : undefined,
                        MRPValue: isRACompany ? tableIndex?.MRPValue : undefined,
                        Rate: stockIndex.Rate,
                        BasicAmount: showDiscount ? Number(calculate.discountBaseAmt).toFixed(2) : calculate.basicAmount,
                        TaxType: "GST",
                        GST: stockIndex.LiveBatcheGSTID,
                        GSTPercentage: stockIndex.GSTPercentage,
                        HSNCode: stockIndex.HSNCode,
                        GSTAmount: calculate.roundedGstAmount,
                        Amount: Number(calculate.roundedTotalAmount).toFixed(2),
                        DiscountType: showDiscount ? tableIndex.DiscountType : "0",
                        Discount: showDiscount ? (Number(tableIndex.Discount) || 0) : "0.00",
                        DiscountAmount: showDiscount ? Number(calculate.disCountAmt).toFixed(2) : "0.00",
                        CGST: calculate.CGST_Amount,
                        SGST: calculate.SGST_Amount,
                        IGST: "0.00",
                        CGSTPercentage: calculate.CGST_Percentage,
                        SGSTPercentage: calculate.SGST_Percentage,
                        IGSTPercentage: calculate.IGST_Percentage,
                        BatchDate: stockIndex.BatchDate,
                        BatchCode: stockIndex.BatchCode,
                        SystemBatchDate: stockIndex.SystemBatchDate,
                        SystemBatchCode: stockIndex.SystemBatchCode,
                        BatchID: ChallanMaster ? stockIndex.LiveBatche : stockIndex.LiveBatche_id
                    };
                    if (parseFloat(tableIndex.Quantity) > 0) {
                        itemArr.push(arr);
                    }
                }
            });
        });

        if (hasZeroRate && subPageMode === url.CHALLAN_MASTER) {
            customAlert({
                Type: 3,
                Message: `Rate cannot be zero for item ${zeroRateItemName}`
            });
            return; // 🚫 stop save
        }

        if (itemArr.length === 0) {
            customAlert({
                Type: 3,
                Message: alertMessages.itemQtyIsRequired
            })
            return;
        }
        if (
            _cfunc.loginSystemSetting().EWayBillApplicable === "1" &&
            subPageMode === url.CHALLAN_MASTER &&
            (!values.DriverName || !values.VehicleNo) &&
            !isRACompany
        ) {
            customAlert({
                Type: 3,
                Message: "Vehicle and Driver are Required"
            })
            return;
        }
        else {
            let challanReferences = [];
            let ChallanMode = 0;

            if (subPageMode === url.CHALLAN_MASTER) {
                challanReferences = [{ Order: Demand_ID.Demand_ID, Demands: null }]; // send OrderId
                ChallanMode = 1;
            }
            else if (subPageMode === url.IB_INVOICE) {
                challanReferences = [{ Order: null, Demands: Demand_ID.Demand_ID }]; // send DemandId
                ChallanMode = 0;
            }
            else if (subPageMode === url.VDC_INVOICE) {
                challanReferences = [];
                ChallanMode = 2;
            }
            const jsonBody = JSON.stringify({
                ChallansReferences: challanReferences,
                ChallanMode: ChallanMode,
                Demand_ID: Demand_ID.Demand_ID,
                ChallanDate: values.ChallanDate,
                Party: (subPageMode === url.VDC_INVOICE) ? customerID.value : _cfunc.loginSelectedPartyID(),
                GrandTotal: Number(grand_total).toFixed(2),
                Customer: (subPageMode === url.VDC_INVOICE) ? _cfunc.loginSelectedPartyID() : customerID.value,
                CreatedBy: _cfunc.loginUserID(),
                UpdatedBy: _cfunc.loginUserID(),
                RoundOffAmount: Math.round(grand_total).toFixed(2),
                IsVDCChallan: (subPageMode === url.VDC_INVOICE) ? 1 : 0,
                ChallanItems: itemArr,
                Driver: values.DriverName?.value || "",
                Vehicle: values.VehicleNo?.value || "",
            });

            Actionhandler({
                transactionDate: values.ChallanDate,  // ✅ pass date here
                action: saveChallan_ChallanAdd,
                params: jsonBody
            });
        }
    }

    if (!(userPageAccessState === '')) {
        return (
            <React.Fragment>
                <MetaTags>{_cfunc.metaTagLabel(userPageAccessState)}</MetaTags>

                <div className="page-content" >

                    <form noValidate>
                        <Col className="px-2 mb-1 c_card_filter header text-black" sm={12}>

                            <div className="row" >
                                <Col sm="3" className="">
                                    <FormGroup className="mb- row mt-2 " >
                                        <Label className="col-sm-8 p-2" style={{ width: "130px" }}>{ChallanMaster ? "Challan Date" : "IB Invoice Date"}</Label>
                                        <Col sm="7">
                                            <C_DatePicker
                                                name="ChallanDate"
                                                value={values.ChallanDate}
                                                id="myInput11"
                                                disabled={(orderItemDetails.length > 0 || pageMode === "edit") ? true : false}
                                                onChange={ChallanDateOnchange}
                                            />
                                            {isError.ChallanDate.length > 0 && (
                                                <span className="invalid-feedback">{isError.ChallanDate}</span>
                                            )}
                                        </Col>
                                    </FormGroup>
                                </Col>
                                {subPageMode === url.CHALLAN_MASTER && (
                                    <Col sm="3">
                                        <FormGroup className="mb- row mt-2">
                                            <Label className="col-sm-6 p-2" style={{ width: "90px" }}>
                                                Driver
                                            </Label>

                                            <Col sm="7">
                                                <Select
                                                    name="DriverName"
                                                    value={values.DriverName}
                                                    options={DriverOptions}
                                                    onChange={(hasSelect) => {
                                                        setState(i => ({
                                                            ...i,
                                                            values: { ...i.values, DriverName: hasSelect }
                                                        }));
                                                    }}
                                                />
                                            </Col>
                                        </FormGroup>
                                    </Col>
                                )}
                                {subPageMode === url.CHALLAN_MASTER && (
                                    <Col sm="3">
                                        <FormGroup className="mb- row mt-2">
                                            <Label className="col-sm-6 p-2" style={{ width: "100px" }}>VehicleNo</Label>
                                            <Col sm="7">
                                                <Select
                                                    name="VehicleNo"
                                                    value={values.VehicleNo}
                                                    isSearchable
                                                    options={VehicleNumber_Options}
                                                    onChange={(hasSelect, evn) =>
                                                        onChangeSelect({ hasSelect, evn, state, setState })
                                                    }
                                                    classNamePrefix="dropdown"
                                                    styles={{ menu: p => ({ ...p, zIndex: 3 }) }}
                                                />
                                            </Col>
                                        </FormGroup>
                                    </Col>

                                )}

                                {subPageMode === url.VDC_INVOICE && <Col sm="3">
                                    <FormGroup className="mb- row mt-2 " >
                                        <Label className="col-md-4 p-2"
                                            style={{ width: "115px" }}>Customer</Label>
                                        <Col md="7">
                                            <Select
                                                value={values.Customer}
                                                classNamePrefix="select2-Customer"
                                                options={venderOptions}
                                                onChange={venderOnchange}
                                                styles={{
                                                    menu: provided => ({ ...provided, zIndex: 3 })
                                                }}
                                            />
                                        </Col>
                                    </FormGroup>
                                </Col >}

                                {subPageMode === url.VDC_INVOICE && <Col sm="3" className="">
                                    <FormGroup className="mb- row mt-2" >
                                        <Label className="col-sm-6 p-2"
                                            style={{ width: "90px" }}>{"VDC Item"}</Label>
                                        <Col sm="7">
                                            <Select
                                                name="VDCItem"
                                                value={values.VDCItem}
                                                isSearchable={true}
                                                id={'VDCItem'}
                                                className="react-dropdown"
                                                classNamePrefix="dropdown"
                                                options={VDCItem_Options}
                                                onChange={ItemOnchange}
                                                styles={{ menu: provided => ({ ...provided, zIndex: 3 }) }}
                                            />

                                        </Col>
                                    </FormGroup>
                                </Col>}


                                {subPageMode === url.VDC_INVOICE && <Col sm="1" ></Col>}
                                {subPageMode === url.VDC_INVOICE && <Col sm="2" className="mt-2 ">
                                    <Go_Button
                                        onClick={goButtonHandler}
                                    />
                                </Col>}

                            </div>
                        </Col>
                        <div className="mb-1">
                            <GlobalCustomTable
                                keyField={"id"}
                                data={tableData}
                                columns={pagesListColumns}
                                id="table_Arrow"
                                noDataIndication={
                                    <div className="text-danger text-center ">
                                        Items Not available
                                    </div>
                                }
                                onDataSizeChange={(e) => {
                                    _cfunc.tableInputArrowUpDounFunc("#table_Arrow")
                                }}
                            />
                        </div>
                        {
                            (tableData.length > 0) &&
                            <SaveButtonDraggable>
                                <SaveButton
                                    loading={saveBtnloading}
                                    id={saveBtnid}
                                    pageMode={pageMode}
                                    userAcc={userPageAccessState}
                                    onClick={saveHandeller}
                                    forceDisabled={saveAndPdfBtnLoading || StockEnteryForFirstYear.status}
                                />

                            </SaveButtonDraggable>
                        }
                    </form >
                </div >

            </React.Fragment >
        );
    }
    else {
        return (
            <React.Fragment></React.Fragment>
        )
    }
};

export default IBInvoice

































